import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { updateRoom } from '../../../clientServices/RoomService'; // Import your room update service function

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const EditRoomModal = ({ open, handleClose, room, updateRoomList }) => {
  const [roomName, setRoomName] = useState('');
  const [roomNumber, setRoomNumber] = useState(''); // State for RoomNumber
  const [roomStatus, setRoomStatus] = useState(true); // Room status as a boolean

  useEffect(() => {
    if (room) {
      setRoomName(room.Name);
      setRoomNumber(room.RoomNumber); // Set initial RoomNumber
      setRoomStatus(room.Status); // Set initial room status
    }
  }, [room]);

  const handleSubmit = async () => {
    try {
      // Check if there are any changes
      if (
        roomName === room.Name &&
        roomNumber === room.RoomNumber
      ) {
        alert('לא נוצרו שינויים, נא לעדכן לפחות פרט אחד');
        return; // Prevent form submission if no changes were made
      }
      if (room.Name === "רופא" && roomName!=="רופא") {
        alert("בחדר רופא ניתן לעדכן את מספר החדר בלבד")
        return;

      }
      else {
        // Proceed with updating the room
        const updatedRoom = {
          ID: room.ID,
          Name: roomName,
          RoomNumber: roomNumber,
          Status: roomStatus,
        };


        await updateRoom(updatedRoom);
        alert('החדר עודכן בהצלחה');
        await handleClose();
        updateRoomList();
        window.location.reload()
      }


    } catch (error) {
      // בדיקת שגיאות שמגיעות מהשרת
      if (error.response && error.response.status === 400) {
        // הצגת הודעת השגיאה מהשרת
        const message = error.response.data.message;
        alert(message);
      } else {
        // טיפול בשגיאה כללית
        alert('אירעה שגיאה בעדכון החדר');
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ fontFamily: 'Segoe UI, sans-serif', fontWeight: 'bold' }}
        >
          עריכת נתוני חדר
        </Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            label="שם חדר"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="מספר חדר"
            value={roomNumber} // Room number input field
            onChange={(e) => setRoomNumber(e.target.value)}
            type="number"
            fullWidth
            sx={{ mb: 2 }}
            inputProps={{ min: "1" }} // Prevent negative numbers
          />
        </Box>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" color="primary" onClick={handleSubmit} sx={{
            backgroundColor: 'blue',
            color: 'white',
            marginRight: 3,
            '&:hover': {
              backgroundColor: 'darkblue'
            }
          }}>
            עדכן חדר
          </Button>
          <Button variant="contained" color="secondary" onClick={handleClose} sx={{
            backgroundColor: 'red',
            color: 'white',
            '&:hover': {
              backgroundColor: 'darkred'
            }
          }}>
            ביטול
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditRoomModal;
